import {Component} from "react";
import {Button, Col, message, Modal, Popconfirm, Row, Space, Table, Tag} from "antd";
import {PredicateDefinition, RouteDefinition} from "../../domains/route-definition";
import RouteEdit from "./route-edit";
import React from "react";
import {request} from "../../utils/utils";
import {AuthGroup} from "../../domains/auth-group";

interface RouteListStatus {
    routeList: RouteDefinition[]
    routeEditVisible: boolean
    selectedRoute?: RouteDefinition
}

export default class RouteList extends Component<any, RouteListStatus> {
    lbUri = "lb://cusLB"
    columns = [
        {
            title: "路由ID",
            dataIndex: "id",
            key: "id",
            render: (text: string) => <label>{text}</label>
        },
        {
            title: "服务地址",
            render: (entity: RouteDefinition) => {
                let address: string[] = []
                if (entity.uri === this.lbUri){
                    address = entity.address
                } else {
                    address = [entity.uri]
                }
                return address.map((x: string) => {
                    return <Tag> {x} </Tag>
                })
            }
        },
        {
            "title": "路由匹配",
            render: (entity: RouteDefinition) => {
                let args = ""
                return entity.predicates.map((x)=>{
                    return <Tag>{x.name} : {x.args.pattern}</Tag>
                })
            }
        },
        {
            title: "过滤器数量（Filters）",
            dataIndex: "filters",
            key: "filters",
            render: (rowData: PredicateDefinition[]) => <label>{rowData.length}</label>
        },
        {
            title: "断路器数量（Predicates）",
            dataIndex: "predicates",
            key: "predicates",
            render: (rowData: PredicateDefinition[]) => <label>{rowData.length}</label>
        },
        {
            title: "操作",
            render: (record: RouteDefinition) => {
                return (
                    <Space>
                        <Button type="primary" onClick={() => this.handleRouteEdit(record)}>修改</Button>
                        <Button type="primary" onClick={() => this.handleEnableChange(record)}>{record.enabled ? "禁用" : "启用"}</Button>
                        <Popconfirm
                            title="确认删除该路由吗？"
                            onConfirm={() => this.handleRouteDelete(record)}
                            okText="删除"
                            cancelText="取消"
                        >
                            <Button danger>删除</Button>
                        </Popconfirm>
                    </Space>
                )
            }
        }
    ]
    routeEditRef = React.createRef<RouteEdit>();

    constructor(props: Readonly<any> | any) {
        super(props);
        this.state = {
            routeList: [],
            routeEditVisible: false
        }
    }

    componentDidMount() {
        this.loadResources()
    }

    loadResources = () => {
        request({
            url: "/gateway/route/",
            method: "GET"
        }).then(
            (res) => {
                this.setState({
                    routeList: res.data
                })
            }
        )
    }

    handleEnableChange = (route: RouteDefinition) => {
        if (route.enabled) {
            request({
                url: "/gateway/route/disable",
                method: "GET",
                params: {id: route.id}
            }).then(res => {
                if (res.data) {
                    message.info("禁用成功，请等待配置生效")
                    this.loadResources()
                } else {
                    message.error("禁用失败，请稍后重试")
                }
            }).catch(ex => {
                message.error("禁用失败，请稍后重试")
            })
        } else {
            request({
                url: "/gateway/route/enable",
                method: "GET",
                params: {id: route.id}
            }).then(res => {
                if (res.data) {
                    message.info("启用成功，请等待配置生效")
                    this.loadResources()
                } else {
                    message.error("启用失败，请稍后重试")
                }
            }).catch(ex => {
                message.error("启用失败，请稍后重试")
            })
        }
    }

    handleRouteEdit = (route: RouteDefinition) => {
        this.setState({routeEditVisible: true, selectedRoute: route})
        this.routeEditRef.current?.fillUpForm(route)
    }

    handleRouteDelete = (route: RouteDefinition) => {
        request({
            method: "DELETE",
            url: "/gateway/route/delete?id=" + route.id,
        }).then((res) => {
            if (res.data) {
                message.info("路由删除成功")
                this.loadResources()
            } else {
                message.error("路由删除失败")
            }
        }).catch((err) => {
            message.error("路由删除失败")
        })
    }

    handleRouteEditOk = () => {
        this.routeEditRef.current!.submitRouteConfig();
    }

    render() {
        return (
            <div>
                <Row style={{margin: 10}}>
                    <Col span={4} offset={20}>
                        <Button type='primary' onClick={() => this.setState({routeEditVisible: true})}>新增路由配置</Button>
                    </Col>
                </Row>
                <Table columns={this.columns} dataSource={this.state.routeList ?? []}/>

                <Modal title="新增路由配置"
                       width={800}
                       visible={this.state.routeEditVisible}
                       onCancel={() => {
                           this.setState({routeEditVisible: false, selectedRoute: undefined})
                           this.routeEditRef.current!.clear()
                       }}
                       onOk={this.handleRouteEditOk}
                       cancelText='取消'
                       okText='新增'
                >
                    <RouteEdit ref={this.routeEditRef} route={this.state.selectedRoute} onRouteConfigSuccess={() => {
                        this.setState({routeEditVisible: false});
                        this.loadResources()
                    }}/>
                </Modal>
            </div>
        )
    }
}
